import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaQuantidade.vue?vue&type=template&id=aaf6562c"
import script from "./ModalSolicitacaoCirurgiaQuantidade.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaQuantidade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports